import React from 'react';

import { MdClose } from 'react-icons/md';
import Confetti from '@src/assets/images/ConfettiMini.svg';

import {
  CloseButton,
  Content,
  ContinueButton,
  DiscountValue,
  Header,
  Icon,
  Message,
  ModalContent,
  Title,
} from './styles';
import useTranslate from '@src/i18n/useTranslate';
import { getContrastColorFrom } from '@src/common/colors';
import { useWidgetsTheme } from '@src/core/theme';

type Props = {
  couponCode: string;
  discount: string;
  affiliateName: string;
  onClose: () => void;
};

const PartnershipModal = (props: Props) => {
  const { couponCode, discount, affiliateName, onClose } = props;

  const mainColor = useWidgetsTheme('actionColor');
  const textColor = getContrastColorFrom(mainColor);

  const { i18nElement } = useTranslate();

  return (
    <>
      <ModalContent>
        <Content>
          <Header>
            <Title>
              <Icon>
                <Confetti />
              </Icon>

              <DiscountValue>
                {i18nElement('partnership_banner_discount', {
                  value: discount,
                })}
              </DiscountValue>
            </Title>

            <CloseButton type='button' onClick={onClose}>
              <MdClose />
            </CloseButton>
          </Header>

          <Message>
            {i18nElement('partnership_banner_message', {
              value: discount,
              affiliateName: affiliateName,
              couponCode: couponCode,
            })}
          </Message>

          <ContinueButton type='button' onClick={onClose} $mainColor={mainColor} $textColor={textColor}>
            {i18nElement('partnership_banner_continue')}
          </ContinueButton>
        </Content>
      </ModalContent>
    </>
  );
};

export default PartnershipModal;
